export const buildCoverageRegistry = ({
  dreadedEvents = [],
  strategicScenarios = [],
  operationalScenarios = [],
  riskScenarioIndexMap = {},
  bvNameById = {},
} = {}) => {
  const eventToRefs = new Map();

  const pushRefs = (eventId, refs) => {
    if (!eventId) return;
    const cur = eventToRefs.get(eventId) || [];
    for (const ref of refs) {
      if (ref && !cur.includes(ref)) cur.push(ref);
    }
    eventToRefs.set(eventId, cur);
  };

  for (const ss of strategicScenarios) {
    const apIds = (ss.attackPaths || []).map(ap => typeof ap === 'string' ? ap : ap.id).filter(Boolean);
    const refs = apIds.map(id => riskScenarioIndexMap[id]?.shortRef).filter(Boolean);
    for (const de of (ss.dreadedEvents || [])) pushRefs(de.id, refs);
  }

  for (const op of operationalScenarios || []) {
    const ref = riskScenarioIndexMap[op.attackPathId]?.shortRef;
    if (ref) for (const de of (op.dreadedEvents || [])) pushRefs(de.id, [ref]);
  }

  const rows = (dreadedEvents || []).map(de => {
    const refs = eventToRefs.get(de.id) || [];
    const bvIdCandidates = [de.businessValueId, de.businessValue].filter(Boolean);
    let bvName = null;
    for (const id of bvIdCandidates) {
      if (bvNameById[id]) { bvName = bvNameById[id]; break; }
      const asString = String(id);
      if (bvNameById[asString]) { bvName = bvNameById[asString]; break; }
    }
    if (!bvName && de.businessValueName) bvName = de.businessValueName;
    return {
      key: de.id || de.name || `de-${Math.random()}`,
      ref: de.referenceCode || de.id || '—',
      name: de.name || de.description || '—',
      bvName,
      severity: de.severity || null,
      coverageJustification: de.coverageJustification || '',
      scenarioRefs: refs,
      isCovered: refs.length > 0,
    };
  });

  rows.sort((a, b) => {
    if (a.isCovered !== b.isCovered) return a.isCovered ? 1 : -1;
    return String(a.ref).localeCompare(String(b.ref));
  });

  return { rows };
};